var map = {
	"./employee/chat.md": "4a92",
	"./employee/kpi.md": "74f9",
	"./employee/motivation.md": "941a",
	"./employee/profile.md": "2ca8",
	"./employee/tasks-personal.md": "0d8e",
	"./hr/calculations.md": "dfe9",
	"./hr/delegation.md": "cefc",
	"./hr/emp-kpi.md": "4314",
	"./hr/formulas.md": "4752",
	"./hr/functions.md": "2c3d",
	"./hr/indicators.md": "9640",
	"./hr/parameters.md": "26cb",
	"./hr/regulation.md": "3499",
	"./hr/structure-import.md": "8810",
	"./hr/structure-manual.md": "c1aa",
	"./hr/targets.md": "be04",
	"./hr/variables.md": "18d8",
	"./integrations/api.md": "9a2b",
	"./integrations/email.md": "3369",
	"./integrations/telegram.md": "096a",
	"./intro/login.md": "d5e7",
	"./intro/roles.md": "b33c",
	"./intro/what-is-step-m.md": "3c16",
	"./manager/tasks.md": "38ae",
	"./manager/team-kpi.md": "227d",
	"./manager/team.md": "1f07"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "213f";